import React, { useState } from "react";
import Image from "next/image";

import { currency } from "../../../config/index";

import styles from "./ProductCounter.module.scss";

const ProductCounter = ({
  title,
  subtitle,
  price,
  initialCount = 0,
  minValue = 0,
  maxValue = null,
}) => {
  /* title: string, subtitle: string, price: number, [initialCount]: number, 
  [minValue]: number, [maxValue]: number,  */

  const [count, setCount] = useState(initialCount);

  const handleIncreaseCount = () => {
    if (typeof maxValue === "number" && count >= maxValue) {
      setCount(maxValue);
      return;
    }

    setCount((prevCount) => prevCount + 1);
  };

  const handleDecreaseCount = () => {
    if (typeof minValue === "number" && count <= minValue) {
      setCount(minValue);
      return;
    }

    setCount((prevCount) => prevCount - 1);
  };

  return (
    <div className={`${styles.counterContainer}`}>
      <div className={`${styles.counterLabel}`}>
        <p>{title}</p>
        <p>{subtitle}</p>
      </div>
      <div className={`${styles.priceContainer}`}>
        <span>{currency.symbol}</span>
        <span>{price}</span>
      </div>
      <div className={`${styles.buttonContainer}`}>
        <button
          className={`${styles.counterButton}`}
          type="button"
          onClick={handleDecreaseCount}
        >
          <span className={`${styles.buttonSymbol}`}>
            <Image
              src={"/assets/img/icons/minus-sign.svg"}
              alt="Minus icon"
              width="30"
              height="30"
            />
          </span>
        </button>
        <label htmlFor="counterInput" name="counterInput"></label>
        <input
          type="number"
          value={count}
          min={minValue}
          max={maxValue ?? ""}
          onChange={(event) => event}
          className={`${styles.numberInput}`}
          name="counterInput"
        />

        <button
          className={`${styles.counterButton}`}
          type="button"
          onClick={handleIncreaseCount}
        >
          <span className={`${styles.buttonSymbol}`}>
            <Image
              src={"/assets/img/icons/plus-sign.svg"}
              alt="Plus icon"
              width="30"
              height="30"
            />
          </span>
        </button>
      </div>
    </div>
  );
};

export default ProductCounter;
